import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzCustomers() {
    const source = axios.CancelToken.source();

    const [customers, setCustomers] = useState<vp.RailzCustomer[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchCustomers = async (requestParams: vp.RailzCustomersRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzCustomers(requestParams, source);
        setCustomers(res.Customers);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setCustomers(undefined);
    };

    return {
      customers,
      fetchCustomers,
      reset,
    };
  };
});

export default initHook({});
